import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="entered"
export default class extends Controller {
  submitForm() {
    this.element.requestSubmit();
  }
}
